export default "__VITE_ASSET__BsHV1umi__"